(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InviteUserController', InviteUserController);

    InviteUserController.$inject = ['$stateParams', '$state', 'Invitation', 'TabDomains', 'AlertService', 'Authority'];

    function InviteUserController ($stateParams, $state, Invitation, TabDomains, AlertService, Authority) {
        var vm = this;
        vm.quantity = 1;
        vm.mailList = [];
        vm.domain = [];
        vm.authority = [];
        vm.oldURL = document.baseURI;

        vm.domains = TabDomains.listByUser();
        Authority.query().$promise.then(function (authorities) {
            vm.authorities = authorities;
        });

        vm.clear = function() {
            if(document.URL === vm.oldURL)
                window.history.back();
            else
                window.location.href=vm.oldURL;
        }

        vm.save = function() {
            vm.isSaving = true;
            var body = {
                email: vm.mailList,
                domains: vm.domain,
                authority: vm.authority
            };
            Invitation.create(body, onSuccess, onError);
        }

        function onSuccess() {
            vm.isSaving = false;
            AlertService.success("Invitations sent successfully");
            $state.reload();
        }

        function onError(error){
            var msg = "";
            if(error.status === 409) {
                angular.forEach(error.data, function (value){
                    msg += value + "; ";
                })
                AlertService.error("Mail already present in the database: " + msg.slice(0, -2));
                angular.forEach(vm.mailList, function (value){
                    if(error.data.indexOf(value) === -1) {
                        vm.deleteEmail(vm.mailList.indexOf(value));
                    }
                })
            }
            vm.isSaving = false;
        }

        vm.deleteEmail = function(index){
            vm.mailList.splice(index, 1);
            vm.domain.splice(index, 1);
            vm.authority.splice(index, 1);
            vm.quantity--;
        };

        vm.addQuantity = function(index){
            if(index === Object.keys(vm.mailList).length -1){
                vm.quantity++;
            }
        };
    }
})();
